import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import PropTypes from 'prop-types';
import * as questionTemplateActions from "../../../actions/questionTemplateActions";
import QuestionEditor from "./QuestionEditorHook";

const QuestionContainerHook = ({ templateKey: propTemplateKey, match = {} }) => {
    const [templateKey, setTemplateKey] = useState("");
    
    // Redux state using useSelector
    const template = useSelector(state => state.questionTemplate);
    
    // Redux dispatch using useDispatch
    const dispatch = useDispatch();

    // Replace componentDidMount with useEffect
    useEffect(() => {
        let key;
        if (!propTemplateKey) {
            key = match.params?.templateKey || "";
        } else {
            key = propTemplateKey;
        }
        setTemplateKey(key);
        dispatch(questionTemplateActions.getQuestionTemplate(key));
    }, [propTemplateKey, match.params?.templateKey, dispatch]);

    // Convert getHtml method to a function
    const getHtml = () => {
        let html;

        if (template !== undefined) {
            html = (
                <div id="QuestionContainer-container-div">
                    <Card>
                        <CardHeader
                            title={"Question: " + (template[templateKey] ? template[templateKey].name : "")}
                            subtitle={"Key: " + templateKey}
                            actAsExpander
                        />
                        <CardContent expandable>
                            <QuestionEditor
                                template={template[templateKey]}
                                templateKey={templateKey}
                                questionDepth={0}
                                width="90%"
                                scrollTo="QuestionContainer-container-div"
                            />
                        </CardContent>
                    </Card>
                </div>
            );
        } else {
            html = <div />;
        }

        return html;
    };

    return (
        <div>
            {getHtml()}
        </div>
    );
};

QuestionContainerHook.defaultProps = {
    match: {},
    templateKey: "",
};

QuestionContainerHook.propTypes = {
    templateKey: PropTypes.string,
    match: PropTypes.object,
};

export default QuestionContainerHook;